module.exports = __webpack_public_path__ + "front/img/d8.3886b75c.png";